import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

// Service e Modelli
import { QuestionnaireService } from '../../core/services/questionnaire.service';
import { MessageService } from 'primeng/api';

// PrimeNG Components
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Toast } from 'primeng/toast';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-checklist-run-bo',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule, ButtonModule, TagModule, Toast, CardModule],
  providers: [MessageService],
  templateUrl: './checklist-run-bo.component.html',
  styleUrls: ['./checklist-run-bo.component.scss'],
})
export class ChecklistRunBoComponent implements OnInit {
  private readonly service = inject(QuestionnaireService);
  private readonly messageService = inject(MessageService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly titleService = inject(Title); // WCAG 2.4.2: Page Title

  // Stato reattivo con Signals
  checklist = signal<any>(null);
  isLoading = signal(true);

  ngOnInit(): void {
    // WCAG 2.4.2: Set descriptive page title
    this.titleService.setTitle('Visualizzazione Checklist - Portale Fiduciari AXA');
    this.loadChecklist();
  }

  private loadChecklist(): void {
    const id = this.route.snapshot.paramMap.get('id');

    if (!id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: "ID Checklist mancante nell'URL",
      });
      this.isLoading.set(false);
      return;
    }

    this.service.getChecklistById(id).subscribe({
      next: (data) => {
        this.checklist.set(data);
        this.isLoading.set(false);
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Caricamento fallito',
        });
        this.isLoading.set(false);
      },
    });
  }

  closeChecklist(): void {
    this.router.navigate(['/list-file-checklist']);
  }

  /**
   * Parse allowedExtensions string into an array
   * Handles formats like ".jpg.png.pdf" or ".jpg;.pdf" or "jpg,pdf"
   */
  parseExtensions(extensions: string | string[] | undefined): string[] {
    if (!extensions) return [];
    if (Array.isArray(extensions)) return extensions;

    // If it's a string, try to split by common delimiters
    let result: string[] = [];

    // Try splitting by semicolon first
    if (extensions.includes(';')) {
      result = extensions
        .split(';')
        .map((e) => e.trim())
        .filter((e) => e);
    }
    // Try splitting by comma
    else if (extensions.includes(',')) {
      result = extensions
        .split(',')
        .map((e) => e.trim())
        .filter((e) => e);
    }
    // Try splitting by dot if it looks like ".jpg.png.pdf"
    else if (extensions.includes('.')) {
      result = extensions
        .split('.')
        .filter((e) => e)
        .map((e) => (e.startsWith('.') ? e : '.' + e));
    }
    // If it's just a plain string, treat it as a single extension
    else if (extensions.trim()) {
      result = [extensions.trim()];
    }

    return result;
  }
}
